/* eslint-disable prettier/prettier */

// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

// ** Design Tokens

const panelWrapperDesignTokens = css`
    ${({ theme: { isDarkMode } }) =>
		isDarkMode
			? css`
					--dz-comp-auth-panel-text-color: var(--dz-sys-text-color);
                    --dz-comp-auth-panel-box-shadow: var(--dz-sys-auth-panel-shadow);
                    --dz-comp-button-outline-text-color: var(--dz-sys-text-color);
					--dz-comp-button-outline-background-color: transparent;
					--dz-comp-button-outline-background-color-hover: var(--dz-ref-color-gray800);
					--dz-comp-button-outline-background-color-active: var(--dz-ref-color-gray900);
                    --dz-comp-button-outline-border-color: var(--dz-ref-color-gray800);
			  `
			: css`
					--dz-comp-auth-panel-text-color: #151515;
                    --dz-comp-auth-panel-box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.6),0 1px 2px -1px rgb(0 0 0 / 0.6);
					--dz-comp-button-outline-text-color: var(--dz-sys-text-color);
					--dz-comp-button-outline-background-color: var(--dz-ref-color-gray500);
					--dz-comp-button-outline-background-color-hover: var(--dz-ref-color-gray300);
					--dz-comp-button-outline-background-color-active: var(--dz-ref-color-gray200);
                    --dz-comp-button-outline-border-color: #878787;
			  `}

`;

// #####################################################

export const StyledPanelWrapper = styled.div`
	${panelWrapperDesignTokens}

	display: block;
`;

// #####################################################
